import React from 'react';
import { Calendar, Download, ChevronDown } from 'lucide-react';
export function Header() {
  return <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-6 sticky top-0 z-10" data-id="element-142">
      <div className="flex items-center gap-4" data-id="element-143">
        <div className="flex items-center gap-2" data-id="element-144">
          <div className="w-8 h-8 rounded-full bg-[#E31837] flex items-center justify-center text-white font-bold text-[10px] tracking-tighter" data-id="element-145">
            RKD
          </div>
          <span className="font-bold text-slate-800 text-sm tracking-tight" data-id="element-146">
            GROUP
          </span>
        </div>

        <div className="h-6 w-px bg-slate-300" data-id="element-147"></div>

        <h1 className="text-slate-500 font-medium text-lg" data-id="element-148">
          Intelligence Platform
        </h1>
      </div>

      <div className="flex items-center gap-4 text-sm text-slate-600" data-id="element-149">
        <button className="flex items-center gap-2 px-3 py-1.5 border border-slate-200 rounded-md hover:bg-slate-50 transition-colors" data-id="element-150">
          <Calendar size={16} className="text-slate-400" data-id="element-151" />
          <span data-id="element-152">Last 30 Days</span>
          <ChevronDown size={16} className="text-slate-400" data-id="element-153" />
        </button>

        <div className="flex items-center gap-2" data-id="element-154">
          <span className="text-slate-500" data-id="element-155">Compare</span>
          <button className="w-10 h-5 rounded-full bg-slate-200 relative transition-colors" data-id="element-156">
            <div className="w-4 h-4 rounded-full bg-white absolute left-0.5 top-0.5 shadow-sm" data-id="element-157"></div>
          </button>
        </div>

        <button className="flex items-center gap-2 px-3 py-1.5 border border-slate-200 rounded-md hover:bg-slate-50 transition-colors" data-id="element-158">
          <Download size={16} className="text-slate-400" data-id="element-159" />
          <span data-id="element-160">Export</span>
        </button>
      </div>
    </header>;
}